
import axios from '../../functions/axios';
import { useState, useEffect } from 'react';
import editButton from '../../assets/images/editButton.png';
import { useNavigate } from "react-router-dom";
import style from './Car.module.css';
import { useAuthContext } from '../../hooks/useAuthContext';
// import './cars.css'

function CarsList(props) {
  const [apiData, setApiData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();
  const { user } = useAuthContext();

  const handleEditCar = (car) => {
    navigate('/EditCar', { state: car });
  };

  const handleFilterCars = (searchQuery) => setSearchQuery(searchQuery.trim().replace(/\s+/, '').toUpperCase());

  const getCarsData = async () => {
    if (!user) return null;
    try {
      const { data: response } = await axios.get(`/car`);
      setApiData(response);
    } catch (error) {
      console.error(error.message);
    }
  };

  useEffect(() => {
    getCarsData()
  }, [user]);

  return (
    <>
      <div className={style.menu}>
        <div className={style.filter}>
          <p>Wyszukaj samochód:</p>
          <input type="search" className="form-control" placeholder="Tablica rejestracyjna" onChange={(e) => handleFilterCars(e.target.value)}></input>
        </div>
        <button className="btn btn-default" onClick={navigate.bind(null, '/addCar')}>Dodaj samochód</button>
      </div>
      <div className={style.container}>
        {
          apiData
            .filter((car) => {
              if (searchQuery === '')
                return true;
              return car.plate.toUpperCase().includes(searchQuery);
            })
            .sort((...args) => {
              const [a, b] = args.map(car => car.plate.toUpperCase());
              return a.localeCompare(b, 'pl', { sensitivity: 'base' });
            })
            .map((car, index) =>(
              <div className={style.car} key={index}>
                <span className={style.carPlate}>{car.plate.toUpperCase()}</span>
                <span className={style.carBrand}>{car.brand || '-'}</span>
                <img className={style.editButton}  src={editButton} onClick={handleEditCar.bind(null, car)} />
                
              </div>
            ))}
      </div>
    </>
  );
}

export default CarsList;